import React, { useState} from 'react';
import { Modal, ModalButton, ModalClose } from '../Modal';
import './ShareDraft.css';

const ShareDraft = ({ formName, patientName, saveDraft }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isShortCodeAvailable, setIsShortCodeAvailable] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [shortCode, setShortCode] = useState('');

	const toggleModal = (newModalState = !isModalOpen) => {
		if (!isModalOpen) {
			setIsShortCodeAvailable(false);
			setShortCode('');
		}

		setIsModalOpen(newModalState);
	};

	const getShortCode = () => {
		setIsLoading(true);

		saveDraft(true, true).then((data) => {
			if (!data.shortCode) {
				console.log('[shareDraft] There was a problem generating the short code. ');
			} else {
				setShortCode(data.shortCode);
				setIsShortCodeAvailable(true);
			}

			setIsLoading(false);
		});
	}

	return (
		<>
			<button className="btn btn-secondary" onClick={toggleModal}>Share Draft</button>
			{
				isModalOpen ?
					<Modal overlayColor={"rgb(0,0,0,0.5)"}>
						<ModalClose handleCloseClick={() => { toggleModal(false) }} />
						<h4 className="mt-2">Share Draft</h4>
						{
							isLoading ?
								<i className="fa fa-refresh fa-spin button-icon-right" />
								: null
						}

						{
							!isLoading && isShortCodeAvailable ?
								<ShortCodeDisplay
									shortCode={shortCode}
								/>
								:
								<ShortCodeConsent
									formName={formName}
									patientName={patientName}
									getShortCode={getShortCode}
								/>
						}

						<ModalButton
							label="Close"
							type="secondary"
							handleButtonClick={() => { toggleModal(false) }}
						/>
					</Modal>
					: null
			}
		</>
	);
}

const ShortCodeConsent = ({ formName, patientName, getShortCode }) => {
	return (
		<>
			<div>You are about to share a draft of: </div>
			<div className="short-code-modal__blue-highlight text-primary">{formName}</div>
			<div>with another user. {patientName && <>It is for patient:</>} </div>
			<div className="short-code-modal__blue-highlight text-primary">{patientName}</div>
			<div>When you click Share, a sharing code will be generated. Do you want to share the draft with another user?</div>
			
			<ModalButton
				label="Share"
				type="primary"
				handleButtonClick={getShortCode}
			/>
		</>
	);
}

const ShortCodeDisplay = ({ shortCode }) => {
	return (
		<>
			<div>
				Your draft sharing code is:
			</div>
			<div className="short-code">
				{shortCode}
			</div>
			<div>
				Share this code with another user so they can view and work on the draft.
			</div>
			<div>
				They will use the code in the draft-sharing tab to open the draft.
			</div>
		</>
	);
}

export default ShareDraft;